import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ServiceintervalDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceinterval-dto';
import { ServiceintervalChartItem, ServiceintervallerDialogData } from '../../../models';
import { ServiceaftaleDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceaftale-dto';
import { GraphService } from 'src/app/services/graph.service';
import moment from 'moment';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-serviceintervaler-dialog',
    templateUrl: './serviceintervaler-dialog.component.html',
    styleUrls: ['./serviceintervaler-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ServiceintervalerDialogComponent implements OnInit {
  serviceaftale: ServiceaftaleDto;
  serviceintervaller: ServiceintervalDto[];
  serviceaftaleid: number;

  constructor(private datePipe: DatePipe, private graph: GraphService, @Inject(MAT_DIALOG_DATA) public data: ServiceintervallerDialogData) {
    this.serviceaftale = data.serviceaftale;
    this.serviceintervaller = data.serviceaftale.serviceintervaller;
    this.serviceaftaleid = data.serviceaftale.id;
  }

  ngOnInit(): void {}

  isCurrentServiceinterval(serviceinterval: ServiceintervalDto): boolean {
    return moment().isBetween(serviceinterval.startDate, serviceinterval.endDate);
  }

  GetEftersynOutsideInterval(serviceinterval: ServiceintervalDto): Date[] {
    var allEftersynDates = serviceinterval.kommendeEftersynDateList.concat(serviceinterval.eftersynDateList.map((y) => y.deadline));

    return allEftersynDates
      .filter((x) => new Date(x) < new Date(serviceinterval.startDate) || new Date(x) > new Date(serviceinterval.endDate))
      .map((y) => new Date(y));
  }

  getTilvalg(serviceinterval: ServiceintervalDto) {
    const names = serviceinterval.tilvalg.map((x) => x.name);
    return names.join(',');
  }

  getMonth(serviceinterval: ServiceintervalDto): ServiceintervalChartItem[] {
    const classes = [
      { date: new Date(this.serviceaftale.startDate), class: 'startDate', comment: 'Startdato' },
      { date: new Date(this.serviceaftale.endDate), class: 'endDate', comment: 'Opsigelsesdato' },
    ];

    serviceinterval.opkraevningDateList.map((x) =>
      classes.push({
        date: new Date(x),
        class: 'opkraevning',
        comment: 'Opkrævning',
      })
    );

    serviceinterval.eftersynDateList.map((x) =>
      classes.push({
        date: new Date(x.deadline),
        class: 'eftersyn',
        comment: x.leveringsDate
          ? 'Eftersyn, Leveringsdato: ' + this.datePipe.transform(x.leveringsDate, 'dd.MM.yyyy') + ', Deadline'
          : 'Eftersyn',
      })
    );

    serviceinterval.kommendeEftersynDateList.map((x) =>
      classes.push({
        date: new Date(x),
        class: 'naesteEftersynDate',
        comment: 'Kommende eftersyn',
      })
    );

    serviceinterval.kommendeOpkraevningerDateList.map((x) =>
      classes.push({
        date: new Date(x),
        class: 'opkraevningDate',
        comment: 'Kommende opkrævning',
      })
    );

    return this.graph.getRange(new Date(serviceinterval.startDate), new Date(serviceinterval.endDate), classes);
  }

  getddOffsetPx(serviceinterval: ServiceintervalDto): string | null {
    if (new Date() < new Date(serviceinterval.startDate) || new Date() > new Date(serviceinterval.endDate)) return null;
    const dd = this.graph.getRange(new Date(serviceinterval.startDate), new Date(), []);
    const ddOffsetPx = dd.length * 16 + 'px';
    return ddOffsetPx;
  }
}
